export default __webpack_public_path__ + "static/media/KK_R_Right_Top_s-cropped.bf44e1ca.svg";